import optionsApi from "./optionsApi";
import { CustomResponse } from "../types/Grant";
import { SecurityClass } from "../pages/companyProfile/AddOrEditSecurityClass";

export async function createSecurityClass(
  data: SecurityClass
): Promise<SecurityClass> {
  return optionsApi
    .post(`v2/securityClass/createSecurityClass`, data)
    .then((res) => res.data);
}

export async function getAllSecurityClasses(): Promise<SecurityClass[]> {
  return optionsApi
    .get(`v2/securityClass/getAllSecurityClasses`)
    .then((res) => res.data.data);
}

export async function updateSecurityClass(
  data: SecurityClass
): Promise<SecurityClass> {
  return optionsApi
    .put(`v2/securityClass/updateSecurityClass`, data)
    .then((res) => res.data);
}

export async function deleteSecurityClass(id: string): Promise<void> {
  return optionsApi
    .delete(`v2/securityClass/deleteSecurityClass`, { params: { id } })
    .then((res) => res.data);
}
